import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0eeac2ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeac2ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eeac2ee')) {
      api.createRecord('0eeac2ee', component.options)
    } else {
      api.reload('0eeac2ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0eeac2ee&scoped=true", function () {
      api.rerender('0eeac2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/product/index.vue"
export default component.exports